module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Templates","newTemplate":"+ New Template","name":"Name","type":"Type","status":"Status"},"et":{"title":"Templates","newTemplate":"+ New Template","name":"Name","type":"Type","status":"Status"},"ru":{"title":"Templates","newTemplate":"+ New Template","name":"Name","type":"Type","status":"Status"}}')
  delete Component.options._Ctor
}
